import { render, staticRenderFns } from "./Unverified.vue?vue&type=template&id=bc25cb86&scoped=true"
import script from "./Unverified.vue?vue&type=script&lang=js"
export * from "./Unverified.vue?vue&type=script&lang=js"
import style0 from "./Unverified.vue?vue&type=style&index=0&id=bc25cb86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc25cb86",
  null
  
)

export default component.exports